import { useState } from 'react';

export default function AdultPartyReservationSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    eventDate: '',
    attendees: '',
    eventType: [],
    extraHour: [],
    additionalRequests: '',
    agreedToTerms: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;

    // ЧЕКБОКСЫ С МНОЖЕСТВЕННЫМ ВЫБОРОМ
    if (type === "checkbox" && (name === "eventType" || name === "extraHour")) {
      const checked = (e.target as HTMLInputElement).checked;

      setFormData(prev => {
        const list = Array.isArray(prev[name]) ? prev[name] : [];

        if (checked) {
          return { ...prev, [name]: [...list, value] };
        } else {
          return { ...prev, [name]: list.filter(v => v !== value) };
        }
      });

      return;
    }

    // ОДИНОЧНЫЕ ЧЕКБОКСЫ (например policies)
    if (type === "checkbox") {
      const checked = (e.target as HTMLInputElement).checked;
      setFormData(prev => ({ ...prev, [name]: checked }));
      return;
    }

    // ТЕКСТОВЫЕ INPUT/TEXTAREA
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.agreedToTerms) {
      alert('Please agree to the policies and reminders before submitting.');
      return;
    }

    if (formData.additionalRequests.length > 500) {
      alert('Additional requests must be 500 characters or less.');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const response = await fetch('/api/event-adult', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          eventDate: formData.eventDate,
          attendees: formData.attendees,
          eventType: formData.eventType,
          extraHour: formData.extraHour,
          additionalRequests: formData.additionalRequests.slice(0, 500),
          agreedToTerms: formData.agreedToTerms
        })
      });

      if (!response.ok) {
        throw new Error('Request failed');
      }

      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        eventDate: '',
        attendees: '',
        eventType: [],
        extraHour: [],
        additionalRequests: '',
        agreedToTerms: false
      });

    } catch (error) {
      console.error(error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus('idle'), 3000);
    }
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left - Form */}
          <div>
            <h2 className="text-3xl font-bold text-[#00889D] mb-8">Make a Reservation</h2>

            <form id="adult-party-form" onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="parentName" className="block text-sm font-medium text-gray-700 mb-2">
                  Name of Parent
                </label>
                <input
                    type="text"
                    name="name"
                    placeholder="Name and Last Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address
                </label>
                <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label htmlFor="contactNumber" className="block text-sm font-medium text-gray-700 mb-2">
                  Contact Number
                </label>
                <input
                    type="tel"
                    name="phone"
                    placeholder="Contact Number"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label htmlFor="eventDate" className="block text-sm font-medium text-gray-700 mb-2">
                  Date of the Event
                </label>
                <input
                    type="date"
                    id="eventDate"
                    name="eventDate"
                    value={formData.eventDate}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label htmlFor="attendees" className="block text-sm font-medium text-gray-700 mb-2">
                  Qty of attendees
                </label>
                <input
                    type="number"
                    name="attendees"
                    placeholder="Qty of attendees"
                    value={formData.attendees}
                    onChange={handleInputChange}
                    min="1"
                    max="20"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Type of event:
                </label>
                <div className="flex space-x-4">
                  <label className="flex items-center">
                    <input
                        type="checkbox"
                        name="eventType"
                        value="Yoga"
                        checked={formData.eventType.includes('Yoga')}
                        onChange={handleInputChange}
                        className="mr-2 text-[#00889D] focus:ring-[#00889D]"
                    />
                    <span className="text-sm">Yoga</span>
                  </label>

                  <label className="flex items-center">
                    <input
                        type="checkbox"
                        name="eventType"
                        value="Dance/Fitness"
                        checked={formData.eventType.includes('Dance/Fitness')}
                        onChange={handleInputChange}
                        className="mr-2 text-[#00889D] focus:ring-[#00889D]"
                    />
                    <span className="text-sm">Dance/Fitness</span>
                  </label>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Extra:
                </label>
                <div className="flex space-x-6">
                  <label className="flex items-center">
                    <input
                        type="checkbox"
                        name="extraHour"
                        value="1 extra hour"
                        checked={formData.extraHour.includes('1 extra hour')}
                        onChange={handleInputChange}
                        className="mr-2 text-[#00889D] focus:ring-[#00889D]"
                    />
                    <span className="text-sm">1 extra hour</span>
                  </label>

                  <label className="flex items-center">
                    <input
                        type="checkbox"
                        name="extraHour"
                        value="TeaCeremony"
                        checked={formData.extraHour.includes('TeaCeremony')}
                        onChange={handleInputChange}
                        className="mr-2 text-[#00889D] focus:ring-[#00889D]"
                    />
                    <span className="text-sm">Tea Ceremony</span>
                  </label>

                  <label className="flex items-center">
                    <input
                        type="checkbox"
                        name="extraHour"
                        value="SoundBathMeditation"
                        checked={formData.extraHour.includes('SoundBathMeditation')}
                        onChange={handleInputChange}
                        className="mr-2 text-[#00889D] focus:ring-[#00889D]"
                    />
                    <span className="text-sm">Sound Bath & Meditation</span>
                  </label>
                </div>
              </div>

              <div>
                <textarea
                    name="additionalRequests"
                    placeholder="Any additional requests:"
                    value={formData.additionalRequests}
                    onChange={handleInputChange}
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00889D] focus:border-transparent text-sm resize-none"
                />
                <div className="text-right text-xs text-gray-500 mt-1">
                  {formData.additionalRequests.length}/500 characters
                </div>
              </div>

              <div className="flex items-start space-x-2">
                <input
                    type="checkbox"
                    name="agreedToTerms"
                    checked={formData.agreedToTerms}
                    onChange={handleInputChange}
                    required
                    className="w-4 h-4 text-[#00889D] focus:ring-[#00889D] mt-1"
                />
                <label className="text-sm text-gray-700">
                  I have read the policies and reminders
                </label>
              </div>

              <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#00889D] text-white py-3 px-6 rounded-lg font-semibold hover:bg-[#007089] transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>

              {submitStatus === 'success' && (
                  <div className="text-green-600 text-center text-sm">
                    Your reservation request has been submitted successfully!
                  </div>
              )}

              {submitStatus === 'error' && (
                  <div className="text-red-600 text-center text-sm">
                    There was an error submitting your request. Please try again.
                  </div>
              )}
            </form>
          </div>

          {/* Right - Policies */}
          <div>
            <h2 className="text-3xl font-bold text-[#00889D] mb-8">Please read our policies:</h2>

            <div className="space-y-4 text-sm text-gray-700">
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p>Waivers required: All guests must sign a waiver prior to or upon arrival.</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p>Shoes-off facility: Our facility is shoes-off. We kindly ask you and your guests to leave your shoes at shoes cabbies in the reception zone. Please follow this policy to help maintain a clean environment.</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p>All food and beverages must be consumed at the tables only</p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p>Clean-up: must be done by the end of your reservation</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p>Garbage & Recycling: all garbage and recycling must be placed in the designated bins provided.</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p>We provide small tables, and guests are seated on floor pillows.</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p>Please avoid bringing glass.</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-[#00889D] rounded-full mt-2 flex-shrink-0"></div>
                <p>If you want to use immersive system with special theme, please let us know</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}